import { observable, action } from 'mobx'
import { colors } from '../variables'

class uiStore {
  @observable backgroundShade = colors.green
  @observable footerBg = ''
  @observable mobileMenuOpen = false

  @action
  setBackgroundShade = (shade: string) => {
    this.backgroundShade = shade
    this.setFooterBg('')
    document.body.style.backgroundColor = shade
  }

  @action
  setFooterBg = (color: string) => {
    this.footerBg = color
  }

  @action toggleMobileMenu = (open: boolean) => {
    this.mobileMenuOpen = open
  }
}

export const UIStore = new uiStore()
